import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import styles from './Agreements.module.css';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 15px',
  },
  formWrapper: {
    '& > *': {
      marginBottom: '15px',
    },
  },
  statement: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    '& > input': {
      marginRight: '10px !important',
      margin: '0px 10px 0px 0px !important',
    },
  },
  checkbox: {
    width: 'inherit',
    height: 'inherit',
    display: 'flex',
    margin: '0 !important',
  },
  label: {
    display: 'flex',
    textAlign: 'left',
    minWidth: '600px',
  },
  title: {
    color: theme.palette.primary.main,
    fontFamily: 'DM Sans , sans-serif',
    fontSize: '40px',
    fontWeight: 'bold',
    alignSelf: 'flex-start',
  },
  requiredAgreement: {
    color: '#FF0000',
  },
}));

const CheckboxWrapper = styled.div`
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
  margin: 0px 10px 0px 0px;
  display: flex;
`;

const Agreements = (props) => {
  const classes = useStyles();

  const { formInfo, setFormInfo } = props;

  const handleForm = (key, value) => {
    const newFormInfo = { ...formInfo, [key]: value };
    setFormInfo(newFormInfo);
  };
  return (
    <div className={classes.root}>
      <p className={classes.title}>Agreements</p>
      <Form>
        <div className={classes.formWrapper}>
          <Row>
            <Form.Check
              type={'checkbox'}
              id={`first`}
              className={classes.statement}>
              <CheckboxWrapper>
                <Form.Check.Input
                  className={classes.checkbox}
                  checked={formInfo.MLHCodeOfConduct}
                  type={'checkbox'}
                  onChange={() => {
                    handleForm('MLHCodeOfConduct', !formInfo.MLHCodeOfConduct);
                  }}
                />
              </CheckboxWrapper>
              <Form.Check.Label className={styles.checkLabel}>
                I have read and agree to the{' '}
                <a
                  target="#"
                  href="https://static.mlh.io/docs/mlh-code-of-conduct.pdf">
                  MLH Code of Conduct
                </a>
                <span className={classes.requiredAgreement}> *</span>
              </Form.Check.Label>
            </Form.Check>
          </Row>
          <Row>
            <Form.Check
              type={'checkbox'}
              id={`second`}
              className={classes.statement}>
              <CheckboxWrapper>
                <Form.Check.Input
                  className={classes.checkbox}
                  checked={formInfo.shareApp}
                  type={'checkbox'}
                  onChange={() => {
                    handleForm('shareApp', !formInfo.shareApp);
                  }}
                />
              </CheckboxWrapper>
              <Form.Check.Label className={styles.checkLabel}>
                <p>
                  I authorize you to share my application/registration
                  information for event administration, ranking, MLH
                  administration, pre- and post-event informational e-mails, and
                  occasional messages about hackathons in-line with the{' '}
                  <a target="#" href="https://mlh.io/privacy">
                    MLH Privacy Policy
                  </a>
                  . I further agree to the terms of both the MLH Contest Terms
                  and Conditions and the{' '}
                  <a target="#" href="https://mlh.io/privacy">
                    MLH Privacy Policy
                  </a>
                  . <span className={classes.requiredAgreement}>*</span>
                </p>
              </Form.Check.Label>
            </Form.Check>
          </Row>
          <Row>
            <Form.Check
              type={'checkbox'}
              id={`fourth`}
              className={classes.statement}>
              <CheckboxWrapper>
                <Form.Check.Input
                  className={classes.checkbox}
                  checked={formInfo.sponsorsShare}
                  type={'checkbox'}
                  onChange={() => {
                    handleForm('sponsorsShare', !formInfo.sponsorsShare);
                  }}
                />
              </CheckboxWrapper>
              <Form.Check.Label className={styles.checkLabel}>
                I give Hack Western permission to share my information with
                sponsors.
              </Form.Check.Label>
            </Form.Check>
          </Row>
        </div>
      </Form>
    </div>
  );
};

export default Agreements;
